'use strict'
const _ = require('lodash')
const Ajv = require('ajv')
const baseDefinitions = require('./baseDefinitions.json')

/**
 * This function creates a validator for properties data.
 * The validation of the data works agents the schema crated by combining:
 *  - BaseDefinition,
 *  - User's customDefinitions
 *  - Properties schema
 * The data to check is an object of with propertyName as key and its data is the value.
 *
 * @param customDefinitions - User defined schemas of property types
 * @param propertiesSchema - Schema of user property to validate data against it
 * @returns function - validation function
 */
const createValidator = (customDefinitions, propertiesSchema) => {
    const generateSchema = propsSchema => ({
        definitions: _.assign(baseDefinitions, customDefinitions),
        additionalProperties: false,
        properties: propsSchema
    })

    const schema = generateSchema(propertiesSchema)

    return {
        validate: data => {
            const ajv = new Ajv({allErrors: true})
            ajv.addMetaSchema(require('ajv/lib/refs/json-schema-draft-06.json'))
            const validate = ajv.compile(schema)
            const valid = validate(data)
            return valid
        }
    }
}

module.exports = {
    createValidator
}